import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.w7i_1 = prereleaseMode;
        this.x7i_1 = auth0ClientId;
        this.y7i_1 = auth0Domain;
        this.z7i_1 = basename;
        this.a7j_1 = expressEnv;
        this.b7j_1 = webpackPublicPath;
        this.c7j_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.w7i_1 + ', auth0ClientId=' + this.x7i_1 + ', auth0Domain=' + this.y7i_1 + ', basename=' + this.z7i_1 + ', expressEnv=' + this.a7j_1 + ', webpackPublicPath=' + this.b7j_1 + ', websocketHost=' + this.c7j_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.w7i_1);
        result = imul(result, 31) + getStringHashCode(this.x7i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y7i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z7i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c7j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.w7i_1 === other.w7i_1))
          return false;
        if (!(this.x7i_1 === other.x7i_1))
          return false;
        if (!(this.y7i_1 === other.y7i_1))
          return false;
        if (!(this.z7i_1 === other.z7i_1))
          return false;
        if (!(this.a7j_1 === other.a7j_1))
          return false;
        if (!(this.b7j_1 === other.b7j_1))
          return false;
        if (!(this.c7j_1 === other.c7j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
